export enum BookingDocumentPaxIdType {
  CC = 'CC',
  PAS = 'PAS',
  CE = 'CE',
  ID_CARD = 'ID_CARD',
  RC = 'RC',
  DNI_AR = 'DNI_AR',
  CUIL = 'CUIL',
  CUIL_UY = 'CUIL_UY',
  CPF = 'CPF',
  RG = 'RG',
  IFE = 'IFE',
  INE = 'INE',
  CURP = 'CURP',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  DNI_PE = 'DNI_PE',
  RUT_CL = 'RUT_CL',
  NONE_ENABLED = 'NONE_ENABLED'
}
